import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tablefield',
  templateUrl: './tablefield.component.html',
  styleUrls: ['./tablefield.component.scss']
})
export class TablefieldComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
